import { createReducer, on } from '@ngrx/store';
import { IEarlyAccessState } from './early-access.interface';
import { EarlyAccessActions } from './early-access.actions';

export const earlyAccessFeatureKey = 'earlyAccess';

export type IState = IEarlyAccessState;

export const initialState: IState = {
	loading: false,
	sending: false,
	launchStatus: null,
};

export const reducer = createReducer(
	initialState,

	// ── API ──

	on(
		EarlyAccessActions.loadLaunchStatus,
		(state): IState => ({
			...state,
			loading: true,
			error: undefined,
		}),
	),
	on(
		EarlyAccessActions.loadLaunchStatusSuccess,
		(state, action): IState => ({
			...state,
			loading: false,
			launchStatus: action.launchStatus,
		}),
	),
	on(
		EarlyAccessActions.loadLaunchStatusError,
		(state, action): IState => ({
			...state,
			loading: false,
			error: action.error,
		}),
	),
	on(
		EarlyAccessActions.sendLaunch,
		(state): IState => ({
			...state,
			sending: true,
			error: undefined,
		}),
	),
	on(
		EarlyAccessActions.sendLaunchSuccess,
		(state): IState => ({
			...state,
			sending: false,
		}),
	),
	on(
		EarlyAccessActions.sendLaunchError,
		(state, action): IState => ({
			...state,
			sending: false,
			error: action.error,
		}),
	),

	// ── UI ──

	on(
		EarlyAccessActions.clearError,
		(state): IState => ({
			...state,
			error: undefined,
		}),
	),
);
